// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-input {
  /* Typography */
  --perxis-auto-input-font-family-inner: var(
    --perxis-auto-input-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-input-font-size-inner: var(
    --perxis-auto-input-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-input-font-weight-inner: var(
    --perxis-auto-input-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-input-letter-spacing-inner: var(
    --perxis-auto-input-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-input-line-height-inner: var(
    --perxis-auto-input-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-input-text-transform-inner: var(
    --perxis-auto-input-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-input-font-variant-numeric-inner: var(
    --perxis-auto-input-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-input-color-inner: var(
    --perxis-auto-input-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-input-disabled-color-inner: var(
    --perxis-auto-input-disabled-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-input-placeholder-color-inner: var(
    --perxis-auto-input-placeholder-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-input-placeholder-hover-color-inner: var(
    --perxis-auto-input-placeholder-hover-color,
    var(--perxis-auto-input-placeholder-color-inner)
  );
  --perxis-auto-input-placeholder-focus-color-inner: var(
    --perxis-auto-input-placeholder-focus-color,
    var(--perxis-auto-input-placeholder-color-inner)
  );
  --perxis-auto-input-placeholder-line-height-inner: var(
    --perxis-auto-input-placeholder-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-input-placeholder-font-size-inner: var(
    --perxis-auto-input-placeholder-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-input-first-color-inner: var(
    --perxis-auto-input-first-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-input-second-color-inner: var(
    --perxis-auto-input-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-input-third-color-inner: var(
    --perxis-auto-input-third-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-input-fourth-color-inner: var(
    --perxis-auto-input-fourth-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-input-fifth-color-inner: var(
    --perxis-auto-input-fifth-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-input-error-color-inner: var(
    --perxis-auto-input-error-color,
    var(--perxis-auto-input-third-color-inner)
  );
  --perxis-auto-input-background-color-inner: var(
    --perxis-auto-input-background-color,
    var(--perxis-auto-input-first-color-inner)
  );
  --perxis-auto-input-hover-background-color-inner: var(
    --perxis-auto-input-hover-background-color,
    var(--perxis-auto-input-first-color-inner)
  );
  --perxis-auto-input-focus-background-color-inner: var(
    --perxis-auto-input-focus-background-color,
    var(--perxis-auto-input-first-color-inner)
  );
  --perxis-auto-input-focus-border-width-inner: var(
    --perxis-auto-input-focus-border-width,
    var(--perxis-auto-input-border-width-inner)
  );
  --perxis-auto-input-filled-background-color-inner: var(
    --perxis-auto-input-filled-background-color,
    var(--perxis-auto-input-background-color-inner)
  );
  --perxis-auto-input-disabled-background-color-inner: var(
    --perxis-auto-input-disabled-background-color,
    var(--perxis-auto-input-fourth-color-inner)
  );
  --perxis-auto-input-border-color-inner: var(
    --perxis-auto-input-border-color,
    var(--perxis-auto-input-fifth-color-inner)
  );
  --perxis-auto-input-hover-border-color-inner: var(
    --perxis-auto-input-hover-border-color,
    var(--perxis-auto-input-second-color-inner)
  );
  --perxis-auto-input-focus-border-color-inner: var(
    --perxis-auto-input-focus-border-color,
    var(--perxis-auto-input-second-color-inner)
  );
  --perxis-auto-input-filled-border-color-inner: var(
    --perxis-auto-input-filled-border-color,
    var(--perxis-auto-input-border-color-inner)
  );
  --perxis-auto-input-disabled-border-color-inner: var(
    --perxis-auto-input-disabled-border-color,
    var(--perxis-auto-input-fifth-color-inner)
  );
  --perxis-auto-input-icon-color-inner: var(
    --perxis-auto-input-icon-color,
    var(--perxis-auto-input-second-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-input-border-radius-inner: var(--perxis-auto-input-border-radius, 8px);
  --perxis-auto-input-border-width-inner: var(--perxis-auto-input-border-width, 2px);
  /* End Border */
  /* Padding */
  --perxis-auto-input-padding-inner: var(--perxis-auto-input-padding, 8px 15px 8px);
  /* End Padding */
  /* Sizes */
  --perxis-auto-input-height-inner: var(--perxis-auto-input-height, 50px);
  --perxis-auto-input-clear-icon-right-inner: var(--perxis-auto-input-clear-icon-right, 14px);
  /* End Sizes */
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_0-input[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_0-input > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_0-input .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_0-input {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--perxis-auto-input-height-inner);
  padding: var(--perxis-auto-input-padding-inner);
  min-height: var(--perxis-auto-input-height-inner);
  box-shadow: none !important;
  border-width: var(--perxis-auto-input-border-width-inner) !important;
  border-style: solid;
  border-color: var(--perxis-auto-input-border-color-inner);
  border-radius: var(--perxis-auto-input-border-radius-inner) !important;
  background-color: var(--perxis-auto-input-background-color-inner);
}
.perxis-auto-1_16_0-input:disabled, .perxis-auto-1_16_0-input[readonly], .perxis-auto-1_16_0-input[class*=disabled], .perxis-auto-1_16_0-input[class*=readonly] {
  background-color: var(--perxis-auto-input-disabled-background-color-inner);
  color: var(--perxis-auto-input-disabled-color-inner);
  border-color: var(--perxis-auto-input-disabled-border-color-inner);
}
.perxis-auto-1_16_0-input:hover:not(:disabled):not([readonly]):not([class*=disabled]):not([class*=readonly]) {
  background-color: var(--perxis-auto-input-hover-background-color-inner);
  border-color: var(--perxis-auto-input-hover-border-color-inner);
}
.perxis-auto-1_16_0-input:hover:not(:disabled):not([readonly]):not([class*=disabled]):not([class*=readonly])::placeholder {
  color: var(--perxis-auto-input-placeholder-hover-color-inner);
}
.perxis-auto-1_16_0-input:focus:not(:disabled):not([readonly]), .perxis-auto-1_16_0-input:focus-visible:not(:disabled):not([readonly]) {
  background-color: var(--perxis-auto-input-focus-background-color-inner);
  border-width: var(--perxis-auto-input-focus-border-width-inner);
  border-color: var(--perxis-auto-input-focus-border-color-inner);
  outline: 0;
}
.perxis-auto-1_16_0-input:focus:not(:disabled):not([readonly])::placeholder, .perxis-auto-1_16_0-input:focus-visible:not(:disabled):not([readonly])::placeholder {
  color: var(--perxis-auto-input-placeholder-focus-color-inner);
}
.perxis-auto-1_16_0-input[type=number] {
  -moz-appearance: textfield;
  -webkit-appearance: none;
  appearance: none;
}
.perxis-auto-1_16_0-input, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper > .ant-5_17_0-input {
  font-family: var(--perxis-auto-input-font-family-inner);
  font-size: var(--perxis-auto-input-font-size-inner);
  line-height: var(--perxis-auto-input-line-height-inner);
  font-weight: var(--perxis-auto-input-font-weight-inner);
  text-transform: var(--perxis-auto-input-text-transform-inner);
  letter-spacing: var(--perxis-auto-input-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-input-font-variant-numeric-inner);
  color: var(--perxis-auto-input-color-inner);
}
.perxis-auto-1_16_0-input::placeholder, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper > .ant-5_17_0-input::placeholder {
  color: var(--perxis-auto-input-placeholder-color-inner);
  line-height: var(--perxis-auto-input-placeholder-line-height-inner);
  font-size: var(--perxis-auto-input-placeholder-font-size-inner);
}
@supports (-webkit-touch-callout: none) {
  .perxis-auto-1_16_0-input, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper > .ant-5_17_0-input {
    font-size: max(var(--perxis-auto-input-font-size-inner), 16px);
  }
}
@supports not (-webkit-touch-callout: none) {
  .perxis-auto-1_16_0-input, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper > .ant-5_17_0-input {
    font-size: var(--perxis-auto-input-font-size-inner);
  }
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper::before {
  content: none;
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper:hover[class*=disabled] {
  background-color: var(--perxis-auto-input-disabled-background-color-inner);
  color: var(--perxis-auto-input-disabled-color-inner);
  border-color: var(--perxis-auto-input-disabled-border-color-inner);
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper[class*=disabled] .ant-5_17_0-input-suffix, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper[class*=readonly] .ant-5_17_0-input-suffix {
  display: none;
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper:has(> .ant-5_17_0-input:focus):not([class*=disabled]):not([class*=readonly]), .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper:has(> .ant-5_17_0-input:focus-visible):not([class*=disabled]):not([class*=readonly]) {
  background-color: var(--perxis-auto-input-focus-background-color-inner);
  border-color: var(--perxis-auto-input-focus-border-color-inner);
  border-width: var(--perxis-auto-input-focus-border-width-inner);
  outline: 0;
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper:has(> .ant-5_17_0-input:focus):not([class*=disabled]):not([class*=readonly]) .ant-5_17_0-input::placeholder, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper:has(> .ant-5_17_0-input:focus-visible):not([class*=disabled]):not([class*=readonly]) .ant-5_17_0-input::placeholder {
  color: var(--perxis-auto-input-placeholder-focus-color-inner);
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper > .ant-5_17_0-input-suffix,
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper > .ant-5_17_0-input-suffix [class*=icon] {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: var(--perxis-auto-input-icon-color-inner);
  vertical-align: initial;
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper > .ant-5_17_0-input-suffix [class*=icon] {
  margin: 0;
  cursor: pointer;
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input, .perxis-auto-1_16_0-input.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input:hover, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless), .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless):hover, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input-affix-wrapper-focused {
  border-color: var(--perxis-auto-input-error-color-inner) !important;
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input, .perxis-auto-1_16_0-input.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input:focus, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless), .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless):focus, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input-affix-wrapper-focused {
  border-color: var(--perxis-auto-input-error-color-inner) !important;
}
.perxis-auto-1_16_0-input.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input, .perxis-auto-1_16_0-input.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input:focused, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless), .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless):focused, .perxis-auto-1_16_0-input.ant-5_17_0-input-affix-wrapper.ant-5_17_0-input-status-error:not(.ant-5_17_0-input-borderless).ant-5_17_0-input-affix-wrapper-focused {
  border-color: var(--perxis-auto-input-error-color-inner) !important;
}

.perxis-auto-1_16_0-textarea {
  /* Sizes */
  --perxis-auto-textarea-height-inner: var(--perxis-auto-textarea-height, 130px);
  --perxis-auto-textarea-min-height-inner: var(--perxis-auto-textarea-min-height, 50px);
  --perxis-auto-textarea-min-height-inner: var(--perxis-auto-textarea-max-height, 260px);
  /* End Sizes */
  /* Padding */
  --perxis-auto-textarea-padding-inner: var(--perxis-auto-textarea-padding, 16px 15px 16px);
  /* End Padding */
}
.perxis-auto-1_16_0-textarea.ant-5_17_0-input {
  font-family: var(--perxis-auto-input-font-family-inner);
  font-size: var(--perxis-auto-input-font-size-inner);
  font-variant-numeric: var(--perxis-auto-input-font-variant-numeric-inner);
  line-height: var(--perxis-auto-input-line-height-inner);
  font-weight: var(--perxis-auto-input-font-weight-inner);
  text-transform: var(--perxis-auto-input-text-transform-inner);
  letter-spacing: var(--perxis-auto-input-letter-spacing-inner);
  color: var(--perxis-auto-input-color-inner);
  height: var(--perxis-auto-textarea-height-inner);
  min-height: var(--perxis-auto-textarea-min-height-inner);
  max-height: var(--perxis-auto-textarea-min-height-inner);
  resize: vertical;
  padding: var(--perxis-auto-textarea-padding-inner);
  border-width: var(--perxis-auto-input-border-width-inner) !important;
  border-style: solid;
  border-color: var(--perxis-auto-input-border-color-inner);
  border-radius: var(--perxis-auto-input-border-radius-inner) !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
